import { render, staticRenderFns } from "./fire_alarm.vue?vue&type=template&id=06fcf159&scoped=true&"
import script from "./fire_alarm.vue?vue&type=script&lang=js&"
export * from "./fire_alarm.vue?vue&type=script&lang=js&"
import style0 from "./fire_alarm.vue?vue&type=style&index=0&id=06fcf159&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fcf159",
  null
  
)

export default component.exports